import {
  iCall,
  iPathObj,
} from '../../shared/communication-module/types'
import { iAuthProcessApi } from '../auth'
import {
  ArchitectureProvider,
  IsAuthenticated,
  IsNotAuthenticated,
  useArq,
} from '../react-utils'
import arq from './mediator'
import { iFacadeApi, iFacadeConfig, iLang } from './types'

// aunque estas variables se inician a undefined serán asignadas durante la
// inicialización de la arquitectura
let env: string

const lang = {} as iLang
let call: iCall
let api: iPathObj
let auth = {} as iAuthProcessApi

export type iFacade = (
  initConfig: iFacadeConfig,
) => Promise<iFacadeApi>
const init: iFacade = async (initConfig) => {
  const apiArq = await arq(initConfig)

  lang.currentLanguage = apiArq.i18n.language
  lang.currentLangCode = apiArq.i18n.langCode
  lang.changeLanguage = apiArq.i18n.changeLanguage
  lang.availableLanguages = initConfig.i18nConfig.availableLanguages

  call = apiArq.call
  api = apiArq.api
  auth = apiArq.auth.auth

  env = apiArq.env

  return {
    lang: {
      availableLanguages: lang.availableLanguages,
      currentLanguage: lang.currentLanguage,
      currentLangCode: lang.currentLangCode,
      changeLanguage: lang.changeLanguage,
    },
    call,
    api,
    auth,
    env,
  }
}

export default init

export {
  api,
  ArchitectureProvider,
  auth,
  call,
  env,
  IsAuthenticated,
  IsNotAuthenticated,
  lang,
  useArq,
}

export * from './types'
